import { useState, useEffect } from "react";
import axios from "axios";

const PostCard = ({ post, refreshPosts }) => {
  const [comment, setComment] = useState("");
  const [badge, setBadge] = useState("");
  const [moderationLabel, setModerationLabel] = useState("");
  const [moderationReason, setModerationReason] = useState(""); // 🌟 BONUS: Tooltip for label reason

  useEffect(() => {
    const fetchBadge = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("http://localhost:5000/api/users/reputation", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setBadge(res.data.badge);
      } catch (err) {
        console.error("Failed to fetch badge");
      }
    };

    const fetchModeration = async () => {
      try {
        const res = await axios.post("http://localhost:5000/api/moderation/analyze", {
          text: post.content,
        });
        setModerationLabel(res.data.label); // e.g., "toxic", "spam"
        setModerationReason(res.data.reason || "");
      } catch (err) {
        console.warn("Moderation check failed");
      }
    };

    fetchBadge();
    fetchModeration();
  }, [post.content]);

  const handleLike = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `http://localhost:5000/api/posts/like/${post._id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      refreshPosts();
    } catch (err) {
      console.error("Error liking post");
    }
  };

  const handleComment = async (e) => {
    e.preventDefault();
    if (!comment.trim()) return;
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `http://localhost:5000/api/posts/comment/${post._id}`,
        { text: comment },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setComment("");
      refreshPosts();
    } catch (err) {
      console.error("Error posting comment");
    }
  };

  // 🎨 Color coding based on label
  const getLabelStyle = (label) => {
    switch (label) {
      case "toxic":
        return "bg-red-200 text-red-800";
      case "spam":
        return "bg-yellow-200 text-yellow-800";
      case "hate":
        return "bg-pink-200 text-pink-800";
      case "fake":
        return "bg-purple-200 text-purple-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="border p-4 rounded mb-4 shadow-sm bg-white relative">
      <div className="flex items-center gap-3 mb-2">
        {post.user?.avatar && (
          <img
            src={post.user.avatar}
            alt="avatar"
            className="w-8 h-8 rounded-full object-cover"
          />
        )}
        <div>
          <div className="font-semibold flex items-center gap-2">
            {post.user?.name}
            <span className="text-xs bg-yellow-200 text-yellow-800 px-2 py-0.5 rounded">
              {badge}
            </span>
          </div>
        </div>
      </div>

      <p className="mb-2">
        {post.content}
        {moderationLabel && (
          <span
            className={`ml-2 text-xs font-semibold px-2 py-1 rounded cursor-help ${getLabelStyle(
              moderationLabel
            )}`}
            title={moderationReason}
          >
            ⚠️ {moderationLabel.toUpperCase()}
          </span>
        )}
      </p>

      <div className="flex items-center gap-4 text-sm text-gray-700">
        <button onClick={handleLike} className="hover:text-blue-600">
          👍 {post.likes.length}
        </button>
      </div>

      <form onSubmit={handleComment} className="flex gap-2 mt-4">
        <input
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Add a comment..."
          className="border px-3 py-1 flex-1 rounded"
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
        >
          Comment
        </button>
      </form>

      <div className="mt-3 space-y-1 text-sm text-gray-800">
        {post.comments.map((c, i) => (
          <div key={i}>
            <strong>{c.user?.name}:</strong>{" "}
            {c.text.split(" ").map((word, idx) =>
              word.startsWith("@") ? (
                <span key={idx} className="text-blue-600 font-semibold">
                  {word}{" "}
                </span>
              ) : (
                word + " "
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostCard;
